const state = {
  mySubscription: null,
  queuedSubscriptions: [],
  myProperties: [],
  myPropertiesMeta: null,
  adminSubscriptions: [],
  adminSubscriptionsMeta: null,
};

export default state;
